"use client";

import { Drawer, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import NoticeContent from "./NoticeContent";
import type { NoticeDialogProps } from "./NoticeTypes";

export default function NoticeDrawerMobile(props: NoticeDialogProps) {
  const { open, onOpenChange } = props;
  const handleClose = () => onOpenChange(false);

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="mx-auto w-full max-w-lg rounded-t-3xl border-0 bg-white px-4 py-4">
        <DrawerHeader className="sr-only">
          <DrawerTitle>Notificación</DrawerTitle>
          <DrawerDescription>Detalle</DrawerDescription>
        </DrawerHeader>
        <NoticeContent layout="drawer" onClose={handleClose} {...props} />
      </DrawerContent>
    </Drawer>
  );
}
